// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixLocation from 'wix-location';

$w.onReady(function () {
	// TODO: write your page related code here...
	$w('#text2').onClick((event) => {
		wixLocation.to("/specialties");
	});
});